export default __webpack_public_path__ + "images/insert-cc.fe7bd714.svg";